import { EquipmentMethod } from 'types/EquipmentMethod'
import {
  BuildingType,
  ObjectType,
  EquipmentMatrixBathroom,
  EquipmentMatrixFloorCovering,
  EquipmentMatrixHeating,
  EquipmentMatrixResidentialArea,
  EquipmentMatrixRoofCovering,
  EquipmentMatrixStoreRoom,
  EquipmentMatrixWindows,
  EquipmentMatrixSurfaceMountedInstallation,
  HouseApartmentType,
  ConstructionType,
  RoofType,
  BasementType,
  BasementConversionType,
  OutdoorFacilitiesType,
  EnergyClassType,
  EnergyCertificateType,
  OwnershipType,
  RentalCurrentUsageType,
  ModernizationMethodType,
} from 'types/ApiResponse'

const confirmText = 'common.yes'
const declineText = 'common.no'

const sharedOptions = [
  { key: 'true', value: confirmText },
  { key: 'false', value: declineText },
]

export const garageSelect = sharedOptions

export const parkingSpace = sharedOptions

export const elevatorSelect = sharedOptions

export const gardenSelect = sharedOptions

export const energyCertificateSelect = sharedOptions

export const includeContactDetailsSelect = sharedOptions

export const heatingSystemSelect = sharedOptions

export const suitableForOwnUseSelect = sharedOptions

export const saunaSelect = sharedOptions

export const fireplaceSelect = sharedOptions

export const insulatedWalls = [
  { key: 'true', value: confirmText },
  { key: 'false', value: declineText },
]

export const guestToilet = [
  { key: 'true', value: confirmText },
  { key: 'false', value: declineText },
]

export const surfaceMountedInstalationEFH = [
  { key: EquipmentMatrixSurfaceMountedInstallation.CABLES_ON_WALLS, value: confirmText },
  { key: EquipmentMatrixSurfaceMountedInstallation.CABLES_NOT_ON_WALLS, value: declineText },
]

export const hausTypeEFHandMFH = [
  {
    label: `houseOrApartmentType.${HouseApartmentType.SEMI_DETACHED_HOUSE.toLowerCase()}`,
    value: HouseApartmentType.SEMI_DETACHED_HOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.DETACHED_HOUSE.toLowerCase()}`,
    value: HouseApartmentType.DETACHED_HOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.END_TERRACED_HOUSE.toLowerCase()}`,
    value: HouseApartmentType.END_TERRACED_HOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.MID_TERRACED_HOUSE.toLowerCase()}`,
    value: HouseApartmentType.MID_TERRACED_HOUSE,
  },
]

export const hausTypeETW = [
  {
    label: `houseOrApartmentType.${HouseApartmentType.ATTIC_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.ATTIC_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.GROUND_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.GROUND_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.MID_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.MID_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.RAISED_FIRST_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.RAISED_FIRST_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.LOFT.toLowerCase()}`,
    value: HouseApartmentType.LOFT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.TWO_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.TWO_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.PENTHOUSE.toLowerCase()}`,
    value: HouseApartmentType.PENTHOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.BASEMENT_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.BASEMENT_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.TERRACED_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.TERRACED_APARTMENT,
  },
]

export const hausTypeETW_AT = [
  {
    label: `houseOrApartmentType.${HouseApartmentType.ATTIC_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.ATTIC_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.ATTIC_PENTHOUSE.toLowerCase()}`,
    value: HouseApartmentType.ATTIC_PENTHOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.GROUND_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.GROUND_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.MID_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.MID_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.LOFT.toLowerCase()}`,
    value: HouseApartmentType.LOFT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.TWO_FLOOR_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.TWO_FLOOR_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.APARTMENT_WITH_GARDEN.toLowerCase()}`,
    value: HouseApartmentType.APARTMENT_WITH_GARDEN,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.PENTHOUSE.toLowerCase()}`,
    value: HouseApartmentType.PENTHOUSE,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.BASEMENT_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.BASEMENT_APARTMENT,
  },
  {
    label: `houseOrApartmentType.${HouseApartmentType.TERRACED_APARTMENT.toLowerCase()}`,
    value: HouseApartmentType.TERRACED_APARTMENT,
  },
]

export const constructionTypes = [
  {
    label: `constructionType.${ConstructionType.MASSIVE.toLowerCase()}`,
    value: ConstructionType.MASSIVE,
  },
  {
    label: `constructionType.${ConstructionType.PREFABRICATED_MASSIVE_HOUSE.toLowerCase()}`,
    value: ConstructionType.PREFABRICATED_MASSIVE_HOUSE,
  },
  {
    label: `constructionType.${ConstructionType.PREFABRICATED_WOOD_HOUSE.toLowerCase()}`,
    value: ConstructionType.PREFABRICATED_WOOD_HOUSE,
  },
]

export const roofTypes = [
  {
    label: `roofType.${RoofType.FLAT.toLowerCase()}`,
    value: RoofType.FLAT,
  },
  {
    label: `roofType.${RoofType.FULLY_DEVELOPED.toLowerCase()}`,
    value: RoofType.FULLY_DEVELOPED,
  },
  {
    label: `roofType.${RoofType.NOT_DEVELOPED.toLowerCase()}`,
    value: RoofType.NOT_DEVELOPED,
  },
  {
    label: `roofType.${RoofType.PARTIALLY_DEVELOPED.toLowerCase()}`,
    value: RoofType.PARTIALLY_DEVELOPED,
  },
]

export const basementTypes = [
  {
    label: `basementType.${BasementType.NONE.toLowerCase()}`,
    value: BasementType.NONE,
  },
  {
    label: `basementType.${BasementType.FULL.toLowerCase()}`,
    value: BasementType.FULL,
  },
  {
    label: `basementType.${BasementType.PARTIAL.toLowerCase()}`,
    value: BasementType.PARTIAL,
  },
]

export const basementConversionTypes = [
  {
    label: `basementConversionType.${BasementConversionType.NONE.toLowerCase()}`,
    value: BasementConversionType.NONE,
  },
  {
    label: `basementConversionType.${BasementConversionType.FULL.toLowerCase()}`,
    value: BasementConversionType.FULL,
  },
  {
    label: `basementConversionType.${BasementConversionType.PARTIAL.toLowerCase()}`,
    value: BasementConversionType.PARTIAL,
  },
]

export const outdoorFacilitiesTypes = [
  {
    label: `outdoorFacilitiesType.${OutdoorFacilitiesType.NONE.toLowerCase()}`,
    value: OutdoorFacilitiesType.NONE,
  },
  {
    label: `outdoorFacilitiesType.${OutdoorFacilitiesType.AVERAGE.toLowerCase()}`,
    value: OutdoorFacilitiesType.AVERAGE,
  },
  {
    label: `outdoorFacilitiesType.${OutdoorFacilitiesType.ABOVE_AVERAGE.toLowerCase()}`,
    value: OutdoorFacilitiesType.ABOVE_AVERAGE,
  },
  {
    label: `outdoorFacilitiesType.${OutdoorFacilitiesType.BELOW_AVERAGE.toLowerCase()}`,
    value: OutdoorFacilitiesType.BELOW_AVERAGE,
  },
]

export const energyClassTypes = [
  {
    label: `energyClassTypes.${EnergyClassType.A_PLUS.toLowerCase()}`,
    value: EnergyClassType.A_PLUS,
  },
  {
    label: `energyClassTypes.${EnergyClassType.A.toLowerCase()}`,
    value: EnergyClassType.A,
  },
  {
    label: `energyClassTypes.${EnergyClassType.B.toLowerCase()}`,
    value: EnergyClassType.B,
  },
  {
    label: `energyClassTypes.${EnergyClassType.C.toLowerCase()}`,
    value: EnergyClassType.C,
  },
  {
    label: `energyClassTypes.${EnergyClassType.D.toLowerCase()}`,
    value: EnergyClassType.D,
  },
  {
    label: `energyClassTypes.${EnergyClassType.E.toLowerCase()}`,
    value: EnergyClassType.E,
  },
  {
    label: `energyClassTypes.${EnergyClassType.F.toLowerCase()}`,
    value: EnergyClassType.F,
  },
  {
    label: `energyClassTypes.${EnergyClassType.G.toLowerCase()}`,
    value: EnergyClassType.G,
  },
  {
    label: `energyClassTypes.${EnergyClassType.H.toLowerCase()}`,
    value: EnergyClassType.H,
  },
]

export const energyCertificateTypes = [
  {
    label: `energyCertificateTypes.${EnergyCertificateType.CONSUMPTION.toLowerCase()}`,
    value: EnergyCertificateType.CONSUMPTION,
  },
  {
    label: `energyCertificateTypes.${EnergyCertificateType.DEMAND.toLowerCase()}`,
    value: EnergyCertificateType.DEMAND,
  },
]

export const heatingType = [
  {
    label: `equipmentMatrix.heating.${EquipmentMatrixHeating.FLOOR_HEATING.toLowerCase()}`,
    value: EquipmentMatrixHeating.FLOOR_HEATING,
  },
  {
    label: `equipmentMatrix.heating.${EquipmentMatrixHeating.STOVES_HEATING.toLowerCase()}`,
    value: EquipmentMatrixHeating.STOVES_HEATING,
  },
  {
    label: `equipmentMatrix.heating.${EquipmentMatrixHeating.CENTRAL_HEATING.toLowerCase()}`,
    value: EquipmentMatrixHeating.CENTRAL_HEATING,
  },
  {
    label: `equipmentMatrix.heating.${EquipmentMatrixHeating.OTHER.toLowerCase()}`,
    value: EquipmentMatrixHeating.OTHER,
  },
]

export const roofCoveringEFHandMFH = [
  {
    label: `equipmentMatrix.roofCovering.${EquipmentMatrixRoofCovering.ROOFING_FELT.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.ROOFING_FELT,
  },
  {
    label: `equipmentMatrix.roofCovering.${EquipmentMatrixRoofCovering.ROOFING_TILES.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.ROOFING_TILES,
  },
  {
    label: `equipmentMatrix.roofCovering.${EquipmentMatrixRoofCovering.METAL.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.METAL,
  },
  {
    label: `equipmentMatrix.roofCovering.${EquipmentMatrixRoofCovering.SLATE.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.SLATE,
  },
  {
    label: `equipmentMatrix.roofCovering.${EquipmentMatrixRoofCovering.OTHER.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.OTHER,
  },
]

export const windowsType = [
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.DOUBLE_GLAZING.toLowerCase()}`,
    value: EquipmentMatrixWindows.DOUBLE_GLAZING,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.TRIPLE_GLAZING.toLowerCase()}`,
    value: EquipmentMatrixWindows.TRIPLE_GLAZING,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.SPECIAL_GLAZING.toLowerCase()}`,
    value: EquipmentMatrixWindows.SPECIAL_GLAZING,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.FLOOR_TO_CEILING_GLAZING.toLowerCase()}`,
    value: EquipmentMatrixWindows.FLOOR_TO_CEILING_GLAZING,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.BOX_WINDOW.toLowerCase()}`,
    value: EquipmentMatrixWindows.BOX_WINDOW,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixWindows.SIMPLE.toLowerCase()}`,
    value: EquipmentMatrixWindows.SIMPLE,
  },
  {
    label: `equipmentMatrix.windows.${EquipmentMatrixRoofCovering.OTHER.toLowerCase()}`,
    value: EquipmentMatrixRoofCovering.OTHER,
  },
]

export const storeETW = [
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.OUTSIDE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.OUTSIDE,
  },
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.INSIDE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.INSIDE,
  },
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.OUTSIDE_AND_INSIDE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.OUTSIDE_AND_INSIDE,
  },
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.NONE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.NONE,
  },
]

export const storeMFH = [
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.OUTSIDE_AND_INSIDE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.OUTSIDE_AND_INSIDE,
  },
  {
    label: `equipmentMatrix.storeRoom.${EquipmentMatrixStoreRoom.NONE.toLowerCase()}`,
    value: EquipmentMatrixStoreRoom.NONE,
  },
]

export const floorETW = [
  {
    label: `equipmentMatrix.floorCovering.${EquipmentMatrixFloorCovering.TILES.toLowerCase()}`,
    value: EquipmentMatrixFloorCovering.TILES,
  },
  {
    label: `equipmentMatrix.floorCovering.${EquipmentMatrixFloorCovering.PLASTIC_PVC.toLowerCase()}`,
    value: EquipmentMatrixFloorCovering.PLASTIC_PVC,
  },
  {
    label: `equipmentMatrix.floorCovering.${EquipmentMatrixFloorCovering.PARQUET_NATURAL_STONE.toLowerCase()}`,
    value: EquipmentMatrixFloorCovering.PARQUET_NATURAL_STONE,
  },
  {
    label: `equipmentMatrix.floorCovering.${EquipmentMatrixFloorCovering.CARPET_LAMINATE.toLowerCase()}`,
    value: EquipmentMatrixFloorCovering.CARPET_LAMINATE,
  },
  {
    label: `equipmentMatrix.floorCovering.${EquipmentMatrixFloorCovering.OTHER.toLowerCase()}`,
    value: EquipmentMatrixFloorCovering.OTHER,
  },
]

export const residentialAreaETW = [
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.WINTER_GARDEN.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.WINTER_GARDEN,
  },
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.BALCONY_ABOVE_10.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.BALCONY_ABOVE_10,
  },
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.BALCONY_UNDER_10.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.BALCONY_UNDER_10,
  },
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.NO_BALCONY.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.NO_BALCONY,
  },
]

export const residentialAreaMFH = [
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.BALCONY_ABOVE_10.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.BALCONY_ABOVE_10,
  },
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.BALCONY_UNDER_10.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.BALCONY_UNDER_10,
  },
  {
    label: `equipmentMatrix.residentialArea.${EquipmentMatrixResidentialArea.NO_BALCONY.toLowerCase()}`,
    value: EquipmentMatrixResidentialArea.NO_BALCONY,
  },
]

export const bathroomEFH = [
  {
    label: `equipmentMatrix.bathroom.${EquipmentMatrixBathroom.MORE_THAN_ONE_BATH.toLowerCase()}`,
    value: EquipmentMatrixBathroom.MORE_THAN_ONE_BATH,
  },
  {
    label: `equipmentMatrix.bathroom.${EquipmentMatrixBathroom.ONE_BATH.toLowerCase()}`,
    value: EquipmentMatrixBathroom.ONE_BATH,
  },
]

export const bathroomETW = [
  {
    label: `equipmentMatrix.bathroom.${EquipmentMatrixBathroom.INSIDE.toLowerCase()}`,
    value: EquipmentMatrixBathroom.INSIDE,
  },
  {
    label: `equipmentMatrix.bathroom.${EquipmentMatrixBathroom.MORE_THAN_ONE_BATH.toLowerCase()}`,
    value: EquipmentMatrixBathroom.MORE_THAN_ONE_BATH,
  },
  {
    label: `equipmentMatrix.bathroom.${EquipmentMatrixBathroom.WITH_WINDOW.toLowerCase()}`,
    value: EquipmentMatrixBathroom.WITH_WINDOW,
  },
]

const rentalCurrentUsage = [
  {
    value: RentalCurrentUsageType.OWNER_OCCUPIED,
  },
  {
    value: RentalCurrentUsageType.PARTIALLY_OWNER_OCCUPIED,
  },
  {
    value: RentalCurrentUsageType.RENTED,
  },
]

const rentalCurrentUsageFiltered = [
  {
    value: RentalCurrentUsageType.OWNER_OCCUPIED,
  },
  {
    value: RentalCurrentUsageType.RENTED,
  },
]

const getEnumValue = (value: any, enums: any, valueField: string) => {
  if (value === null || value === undefined) {
    return value
  }
  const validValue = enums.find((item: any) => item[valueField] === value)
  if (validValue !== undefined) {
    return value
  } else {
    return null
  }
}

const getBuildingType = (objectType: ObjectType) => {
  switch (objectType) {
    case ObjectType.APARTMENT:
      return BuildingType.APARTMENT
    case ObjectType.HOUSE:
      return BuildingType.SINGLE_FAMILY_HOUSE
    case ObjectType.MULTI_FAMILY_HOUSE:
      return BuildingType.MULTI_FAMILY_HOUSE
    case ObjectType.PLOT_OF_LAND:
      return null
  }
}

export const getEquipmentLevelRequest = (addressData: any) => {
  const { propertyDetails, leadDetails, indexDetails, ...address } = addressData
  const { equipmentMatrix, ...propertyDetailsRest } = propertyDetails
  return {
    ...address,
    ...propertyDetailsRest,
    ...equipmentMatrix,
  }
}

const parseNumber = (number?: string) => {
  if (number) return parseFloat(number.replace(',', '.'))
  else return number
}

export const sanitizeAddressData = (addressData: any) => {
  const heatingSystemDisabled =
    addressData.propertyDetails?.equipmentMatrix?.heating !==
      EquipmentMatrixHeating.FLOOR_HEATING &&
    addressData.propertyDetails?.equipmentMatrix?.heating !== EquipmentMatrixHeating.CENTRAL_HEATING
  let result = Object.assign(
    {},
    {
      id: addressData.id,
      nation: addressData.nation,
      zip: addressData.zip,
      town: addressData.town,
      street: addressData.street,
      houseNumber: addressData.houseNumber,
      lat: addressData.lat,
      lng: addressData.lng,
      isCopy: addressData.isCopy,
      // valuationDate: addressData.valuationDate,
      propertyDetails: {
        objectType: addressData.propertyDetails.objectType,
        constructionYear: addressData.propertyDetails.constructionYear,
        livingArea: parseNumber(addressData.propertyDetails.livingArea),
        garages: addressData.propertyDetails.garages,
        outdoorParkingSpaces: addressData.propertyDetails.outdoorParkingSpaces,
        equipmentValue: addressData.propertyDetails.equipmentValue,
        equipmentMethod: addressData.propertyDetails.equipmentMethod,
        ownership: addressData.propertyDetails.ownership,
        coownershipNumerator:
          addressData.propertyDetails.ownership === OwnershipType.FULL ||
          addressData.propertyDetails.ownership === OwnershipType.LEASE
            ? null
            : parseNumber(addressData.propertyDetails.coownershipNumerator),
        coownershipDenominator:
          addressData.propertyDetails.ownership === OwnershipType.FULL ||
          addressData.propertyDetails.ownership === OwnershipType.LEASE
            ? null
            : parseNumber(addressData.propertyDetails.coownershipDenominator),
        groundLeaseActualRent:
          addressData.propertyDetails.ownership !== OwnershipType.FULL
            ? parseNumber(addressData.propertyDetails.groundLeaseActualRent)
            : null,
        groundLeaseRemainingTerm:
          addressData.propertyDetails.ownership !== OwnershipType.FULL
            ? addressData.propertyDetails.groundLeaseRemainingTerm
            : null,
        ...(addressData.propertyDetails.equipmentMatrix
          ? {
              equipmentMatrix: {
                insulatedExteriorWalls:
                  addressData.propertyDetails.equipmentMatrix.insulatedExteriorWalls,
                heating: addressData.propertyDetails.equipmentMatrix.heating,
                heatingSystem: !heatingSystemDisabled
                  ? addressData.propertyDetails.equipmentMatrix.heatingSystem
                  : null,
                windows: addressData.propertyDetails.equipmentMatrix.windows,
                guestToilet: addressData.propertyDetails.equipmentMatrix.guestToilet,
              },
            }
          : {}),
        reportImage: addressData.propertyDetails.reportImage,
        reportImageMimeType: addressData.propertyDetails.reportImageMimeType,
        energyCertificate: addressData.propertyDetails.energyCertificate
          ? {
              energyClass: addressData.propertyDetails.energyCertificate.energyClass,
              certificateType: addressData.propertyDetails.energyCertificate.certificateType,
              issueDate: addressData.propertyDetails.energyCertificate.issueDate,
              primaryEnergyDemand: parseNumber(
                addressData.propertyDetails.energyCertificate.primaryEnergyDemand
              ),
              finalEnergyDemand: parseNumber(
                addressData.propertyDetails.energyCertificate.finalEnergyDemand
              ),
              co2Emission: parseNumber(addressData.propertyDetails.energyCertificate.co2Emission),
            }
          : null,
        ...(addressData.propertyDetails.constructionYear <= new Date().getFullYear() - 10
          ? {
              modernizationMethod: addressData.propertyDetails.modernizationMethod,
              refurbishmentYear:
                addressData.propertyDetails.modernizationMethod !==
                ModernizationMethodType.AUTOMATIC
                  ? addressData.propertyDetails.refurbishmentYear
                  : null,
              modernizationValue:
                addressData.propertyDetails.modernizationMethod === ModernizationMethodType.SIMPLE
                  ? addressData.propertyDetails.modernizationValue
                  : null,
              modernizationCost:
                addressData.propertyDetails.modernizationMethod === ModernizationMethodType.COSTS
                  ? parseNumber(addressData.propertyDetails.modernizationCost)
                  : null,
              modernizationCostDescription:
                addressData.propertyDetails.modernizationMethod === ModernizationMethodType.COSTS
                  ? addressData.propertyDetails.modernizationCostDescription
                  : null,
              modernizationMatrix:
                addressData.propertyDetails.modernizationMethod === ModernizationMethodType.DETAILED
                  ? addressData.propertyDetails.modernizationMatrix
                  : null,
            }
          : {}),
      },
      ...(addressData.indexDetails
        ? {
            indexDetails: {
              reportType: addressData.indexDetails.reportType,
              periodType: addressData.indexDetails.periodType,
              includeContactDetails: addressData.indexDetails.includeContactDetails,
            },
          }
        : {}),
    }
  )
  switch (addressData.propertyDetails.objectType) {
    case ObjectType.HOUSE:
      result = Object.assign(result, {
        propertyDetails: {
          ...result.propertyDetails,
          buildingType: addressData.propertyDetails?.buildingType
            ? addressData.propertyDetails?.buildingType
            : getBuildingType(addressData.propertyDetails.objectType),
          houseOrApartmentType: getEnumValue(
            addressData.propertyDetails.houseOrApartmentType,
            hausTypeEFHandMFH,
            'value'
          ),
          plotArea: parseNumber(addressData.propertyDetails.plotArea),
          commercialArea: null,
          numberOfUnits: null,
          numberOfCommercialUnits: null,
          construction: addressData.propertyDetails.construction,
          roof: addressData.propertyDetails.roof,
          basement: addressData.propertyDetails.basement,
          basementConversion:
            addressData.propertyDetails.basement !== BasementType.NONE
              ? addressData.propertyDetails.basementConversion
              : null,
          outdoorFacilities: addressData.propertyDetails.outdoorFacilities,
          elevator: null,
          garden: null,
          floorNumber: null,
          numberOfFloors: addressData.propertyDetails.numberOfFloors,
          rentalCurrentUsage: getEnumValue(
            addressData.propertyDetails.rentalCurrentUsage,
            getBuildingType(addressData.propertyDetails.objectType) ===
              BuildingType.SINGLE_FAMILY_HOUSE
              ? rentalCurrentUsageFiltered
              : rentalCurrentUsage,
            'value'
          ),
          ...(addressData.propertyDetails.equipmentMatrix
            ? {
                equipmentMatrix: {
                  ...result.propertyDetails.equipmentMatrix,
                  bathroom: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.bathroom,
                    bathroomEFH,
                    'value'
                  ),
                  roofCovering: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.roofCovering,
                    roofCoveringEFHandMFH,
                    'value'
                  ),
                  storeRoom: null,
                  surfaceMountedInstallation: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.surfaceMountedInstallation,
                    surfaceMountedInstalationEFH,
                    'key'
                  ),
                  residentialArea: null,
                  floorCovering: null,
                  fireplace: addressData.propertyDetails.equipmentMatrix.fireplace,
                  sauna: addressData.propertyDetails.equipmentMatrix.sauna,
                },
              }
            : {}),
        },
      })
      break
    case ObjectType.APARTMENT:
      result = Object.assign(result, {
        propertyDetails: {
          ...result.propertyDetails,
          buildingType: BuildingType.APARTMENT,
          houseOrApartmentType: getEnumValue(
            addressData.propertyDetails.houseOrApartmentType,
            hausTypeETW,
            'value'
          ),
          plotArea:
            `${addressData.propertyDetails.suitableForOwnUse}` === 'false'
              ? parseNumber(addressData.propertyDetails.plotArea)
              : null,
          commercialArea: null,
          numberOfUnits: addressData.propertyDetails.numberOfUnits,
          numberOfCommercialUnits: null,
          construction: null,
          roof: null,
          basement: null,
          basementConversion: null,
          outdoorFacilities: null,
          elevator: addressData.propertyDetails.elevator,
          garden: addressData.propertyDetails.garden,
          floorNumber: addressData.propertyDetails.floorNumber,
          numberOfFloors: null,
          rentalCurrentUsage: getEnumValue(
            addressData.propertyDetails.rentalCurrentUsage,
            rentalCurrentUsageFiltered,
            'value'
          ),
          suitableForOwnUse:
            addressData.propertyDetails.rentalCurrentUsage === RentalCurrentUsageType.OWNER_OCCUPIED
              ? null
              : addressData.propertyDetails.suitableForOwnUse,
          ...(addressData.propertyDetails.rentalInformation?.actualRent
            ? {
                rentalInformation: {
                  actualRent: parseNumber(
                    addressData.propertyDetails.rentalInformation?.actualRent
                  ),
                  actualRentReference:
                    addressData.propertyDetails.rentalInformation?.actualRentReference,
                },
              }
            : null),
          ...(addressData.propertyDetails.equipmentMatrix
            ? {
                equipmentMatrix: {
                  ...result.propertyDetails.equipmentMatrix,
                  bathroom: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.bathroom,
                    bathroomETW,
                    'value'
                  ),
                  roofCovering: null,
                  storeRoom: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.storeRoom,
                    storeETW,
                    'value'
                  ),
                  surfaceMountedInstallation: null,
                  residentialArea: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.residentialArea,
                    residentialAreaETW,
                    'value'
                  ),
                  floorCovering: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.floorCovering,
                    floorETW,
                    'value'
                  ),
                  fireplace: null,
                  sauna: null,
                },
              }
            : {}),
        },
      })
      break
    case ObjectType.MULTI_FAMILY_HOUSE:
      result = Object.assign(result, {
        propertyDetails: {
          ...result.propertyDetails,
          buildingType: addressData.propertyDetails?.buildingType
            ? addressData.propertyDetails?.buildingType
            : getBuildingType(addressData.propertyDetails.objectType),
          houseOrApartmentType: null,
          plotArea: parseNumber(addressData.propertyDetails.plotArea),
          commercialArea:
            addressData.propertyDetails.buildingType === BuildingType.RESIDENTIAL_AND_COMMERCIAL
              ? parseNumber(addressData.propertyDetails.commercialArea)
              : null,
          numberOfUnits: addressData.propertyDetails.numberOfUnits,
          numberOfCommercialUnits:
            addressData.propertyDetails.buildingType === BuildingType.RESIDENTIAL_AND_COMMERCIAL
              ? addressData.propertyDetails.numberOfCommercialUnits
              : null,
          construction: null,
          roof: null,
          basement: null,
          basementConversion: null,
          outdoorFacilities: null,
          elevator: addressData.propertyDetails.elevator,
          garden: null,
          floorNumber: null,
          numberOfFloors: addressData.propertyDetails.numberOfFloors,
          rentalCurrentUsage: null,
          ...(addressData.propertyDetails.rentalInformation?.actualRent ||
          addressData.propertyDetails.rentalInformation?.actualCommercialRent
            ? {
                rentalInformation: {
                  actualRent: parseNumber(
                    addressData.propertyDetails.rentalInformation?.actualRent
                  ),
                  actualRentReference:
                    addressData.propertyDetails.rentalInformation?.actualRentReference,
                  actualCommercialRent: parseNumber(
                    addressData.propertyDetails.rentalInformation?.actualCommercialRent
                  ),
                  actualCommercialRentReference:
                    addressData.propertyDetails.rentalInformation?.actualCommercialRentReference,
                },
              }
            : null),
          ...(addressData.propertyDetails.equipmentMatrix
            ? {
                equipmentMatrix: {
                  ...result.propertyDetails.equipmentMatrix,
                  bathroom: null,
                  roofCovering: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.roofCovering,
                    roofCoveringEFHandMFH,
                    'value'
                  ),
                  storeRoom: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.storeRoom,
                    storeMFH,
                    'value'
                  ),
                  surfaceMountedInstallation: null,
                  residentialArea: getEnumValue(
                    addressData.propertyDetails.equipmentMatrix.residentialArea,
                    residentialAreaMFH,
                    'value'
                  ),
                  floorCovering: null,
                  fireplace: null,
                  sauna: null,
                },
              }
            : {}),
        },
      })
      break
    case ObjectType.PLOT_OF_LAND:
      result = Object.assign(result, {
        propertyDetails: {
          objectType: addressData.propertyDetails.objectType,
          plotArea: parseNumber(addressData.propertyDetails.plotArea),
          ownership: OwnershipType.FULL,
        },
        indexDetails: null,
      })
      break
  }

  if (
    result.propertyDetails.equipmentMethod === EquipmentMethod.DETAILED ||
    result.propertyDetails.equipmentMethod === EquipmentMethod.AUTOMATIC
  ) {
    delete result.propertyDetails.equipmentValue
  }

  return result
}

export const handleNumberInput = (event, commaAllowed = false) => {
  const isDigit = /^\d$/.test(event.key)
  const isComma = event.key === ','
  if (isDigit) {
    return
  }
  if (commaAllowed && isComma) {
    return
  }
  event.preventDefault()
}
